export default __webpack_public_path__ + "static/media/marauders-map-v4-03-01.8eadd4db.jpg";